export default class LinkInlineTool {

    static get isInline() {
        return true;
    }

    constructor({ api }) {
        this.api = api;
        this.button = null;
        this._state = false;

        this._range = null;
        this._linkElem = null;

        this.linkTypes = [
            { label: "In-text Amazon link", value: "link-amazon" },
            { label: "In-text internal link", value: "link-internal" },
            { label: "External authority link", value: "link-authority" },
            { label: "Other", value: "other" },
            { label: "None", value: "none" },
        ]
    }

    render() {
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.innerHTML = `<i class="fad fa-link"></i>`;
        this.button.classList.add(this._state ? this.api.styles.inlineToolButtonActive : this.api.styles.inlineToolButton);
        return this.button;
    }

    renderActions() {
        this.actionWrapper = document.createElement("div");
        this.actionWrapper.classList.add("listActionWrapper");

        // link URL
        let linkInput = document.createElement('input');
        linkInput.type = "text";
        linkInput.classList.add('linkInput', 'ce-inline-tool-input', 'ce-inline-tool-input--showed', 'ce-inline-tool--active');
        linkInput.placeholder = "Insert link here ...";
        linkInput.addEventListener('keyup', (e) => {
            this._linkElem.setAttribute("href", e.target.value);
        });
        this.actionWrapper.appendChild(linkInput);
        linkInput.focus();

        this.linkTypes.forEach(type => {
            // g: group
            let g = document.createElement('div');
            g.classList.add("inputGroup");
            
            // r: radio
            let r = document.createElement('input');
            r.name = "linkType";
            r.type = "radio";
            r.id = type.value;
            r.value = type.value;
            if(this.linkType == type.value) r.checked = true;
            let l = document.createElement("label");
            l.setAttribute('for', type.value);
            l.innerText = type.label;

            g.appendChild(r);
            g.appendChild(l);

            this.actionWrapper.appendChild(g);

            r.addEventListener("change", (e) => {
                this.linkType = e.target.value;
                this._linkElem.setAttribute("data-linkType", e.target.value);
            })
        })

        return this.actionWrapper;
    }

    _showActions() {
        this.actionWrapper.classList.remove('--hide');
    }

    _hideActions() {
        this.actionWrapper.classList.add('--hide');
    }

    surround(range) {
        this._range = range;

        if (this.state) {
            this.unwrap(range);
        } else this.wrap(range);
    }

    wrap(range) {
        const selectedText = range.extractContents();

        // Create link
        let linkElem = document.createElement('a');
        linkElem.setAttribute('href', "");
        linkElem.setAttribute('data-linkType', this.linkType);
        linkElem.appendChild(selectedText);
        range.insertNode(linkElem);

        this.api.selection.expandToTag(linkElem);
    }

    unwrap(range) {
        const link = this.api.selection.findParentTag('A');
        const text = range.extractContents();
        link.remove();
        range.insertNode(text);
    }

    checkState() {
        this._linkElem = this.api.selection.findParentTag('A');
        if (this._linkElem) {
            this._state = true;
            this.linkType = this._linkElem.getAttribute("data-linkType") || "other";
            document.querySelector(`input[value=${this.linkType}]`).checked = true;
            document.querySelector(`input.linkInput`).value = this._linkElem.getAttribute("href");
            this._showActions();
        } else {
            this._state = false;
            this.linkType = this.linkTypes[0].value;
            this._hideActions();
        }
        this.button.classList.toggle(this.api.styles.inlineToolButtonActive, this._state);
    }

    clear() {
        this._hideActions();
    }

    static get sanitize() {
        return {
            a: true
        };
    }
}